/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === Math.floor(n) && (n >= 0 && n <= 1))
    return 1;
return 5;
}

export default ["csw",[["ᐊᒼ","ᐲᒼ"],u,["ᐁᒼ","ᐲᒼ"]],[["ᐊᒼ","ᐲᒼ"]],[["ᐊ","ᐴ","ᓃ","ᐋ","ᐴ","ᑫ","ᒫ"],["ᐊᔭᒥᐦᐁᑮᓯᑳᐤ","ᐴᓂ ᐊᔭᒥᐦᐁᑮᓯᑳᐤ","ᓃᓱᑮᓯᑳᐤ","ᐋᐱᐦᑕᐘᐣ","ᐴᓂᐋᐱᐦᑕᐘᐣ","ᑫᑳᐨ ᒫᑎᓇᐍᑮᓯᑳᐤ","ᒫᑎᓇᐍᑮᓯᑳᐤ"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["ᐅᒉᒥᑮᓯᑳᐏᐲᓯᒼ","ᐸᐚᐦᒐᑭᓇᓰᐢ","ᒥᑭᓯᐏᐲᓯᒼ","ᓂᐢᑭᐲᓯᒼ","ᐊᓃᑭᐲᓯᒼ","ᐚᐏᐲᓯᒼ","ᐹᐢᑲᐦᐋᐏᐲᓯᒼ","ᐅᐸᐦᐅᐏᐲᓯᒼ","ᓄᒌᑐᐏᐲᓯᒼ","ᐱᓈᐢᑯᐏᐲᓯᒼ","ᐋᕽᐘᑎᓄᐏᐲᓯᒼ","ᒪᑯᓭᑮᓭᑳᐏᐲᓯᒼ"]],u,[["BCE","CE"]],0,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"CAD","CA$","ᑲᓀᑎᔭᐣ ᐯᔭᐠᐚᐱᐢᐠ",{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
